import { useState, useEffect } from "react";
import { api, ApiError } from "../lib/api-client";

interface AuthState {
  isLoading: boolean;
  isAuthenticated: boolean;
  user: {
    userId: string;
    tenantId: string;
    email: string;
    name: string;
    permissions: string[];
  } | null;
}

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({
    isLoading: true,
    isAuthenticated: false,
    user: null,
  });

  useEffect(() => {
    api
      .get<AuthState["user"]>("/auth/session")
      .then((user) => {
        setState({ isLoading: false, isAuthenticated: true, user });
      })
      .catch((err) => {
        // 401 is handled by api-client (redirects to login)
        if (err instanceof ApiError && err.status === 401) return;
        setState({ isLoading: false, isAuthenticated: false, user: null });
      });
  }, []);

  return state;
}
